<div class="pointer-events-none flex gap-x-2 z-20" #previewsContainer>

    @for (preview of previews; track $index) {
        <app-preview 
            [preview]="preview" 
            (openView)="checkPreviews($event)" 
            (previewError)="handlePreviewError($event)"
        />
    }

</div>